import requests from "./httpService";

const AdvertisementServices = {
  getAllAdvertisement: async () => {
    return requests.get(`/advertisementone/`);
  },

  updateAdvertisement: async (body) => {
    return requests.put(`/advertisementone/update/`, body);
  },
  getAllAdvertisementtwo: async () => {
    return requests.get(`/advertisementtwo/`);
  },

  updateAdvertisementtwo: async (body) => {
    return requests.put(`/advertisementtwo/update/`, body);
  },
};

export default AdvertisementServices;
